import React from 'react';
import {TouchableOpacity} from 'react-native';
import {images} from '../../../../assets/icons';
import {useStyles} from '../../../../shared/hooks/styles';
import {useTheme} from '../../../../shared/theme';
import {ViewProps} from './model';

export default ({onPress, adjustFor}: ViewProps) => {
  const theme = useTheme();

  const styles = useStyles(() => ({
    qrCodeIcon: {
      flex: 1,
      width: 50,
      height: 50,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      zIndex: 5,
    },
    adjustmentInput: {
      overflow: 'visible',
      marginRight: -6,
      marginBottom: 0,
    },
    qrCodeImage: {
      opacity: 0.7,
    },
  }));

  let adjustmentStyle;

  switch (adjustFor) {
    case 'input':
      adjustmentStyle = styles.adjustmentInput;
  }
  return (
    <TouchableOpacity testID='qr-code-icon-id' style={[styles.qrCodeIcon, adjustmentStyle]} onPress={onPress}>
      <images.QrCode color={theme.color.textColor} width={20} height={20} style={styles.qrCodeImage} />
    </TouchableOpacity>
  );
};
